import { Badge } from '@neo/primitives/badge'
import { pluralize } from '@shared/utils'
import type { KBRow } from './detail.config'

// Count badges for a source row. The TRUE total is document_count (subRows is the capped top-N,
// errored-first display list from rag). When more exist than are rendered, note "showing first M";
// when pages failed, a red "K failed" badge — the failures sort to the top of the expanded list.
// Its own file (exported component) so React Fast Refresh tracks it and the config file stays
// config-only.
export const CountBadges = ({ noun, original }: { noun: string; original: KBRow }) => {
  const shown = Array.isArray(original.subRows) ? original.subRows.length : 0
  const total = original.document_count ?? shown
  const errs = original.error_count ?? 0
  const empties = original.empty_count ?? 0
  if (total <= 0) return null
  return (
    <>
      <Badge variant="count" className="ml-2" data-testid="badge-documents-count">
        {pluralize(total, noun)}
      </Badge>
      {total > shown && shown > 0 && (
        <span className="ml-1 text-xs-400 text-muted-foreground">showing first {shown}</span>
      )}
      {errs > 0 && (
        <Badge
          variant="destructive"
          className="ml-1 font-jetbrains text-label uppercase tabular-nums"
          data-testid="badge-documents-failed"
        >
          {errs} failed
        </Badge>
      )}
      {/* Empty pages are benign (no content), NOT failures — muted, never the destructive red. */}
      {empties > 0 && (
        <span
          className="ml-1 text-xs-400 text-muted-foreground"
          data-testid="badge-documents-empty"
        >
          {empties} empty
        </span>
      )}
    </>
  )
}
